import { useEffect } from "react";

/**
 * Lightweight document head manager. Updates title + meta tags on route change.
 * Avoids adding a dep on react-helmet; sufficient for static-content SEO.
 */
export default function SEO({ title, description, path = "/" }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [, key, val] = selector.match(/\[(.+?)="(.+?)"\]/) || [];
        if (key && val) el.setAttribute(key, val);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
    }
    if (title) {
      setMeta('meta[property="og:title"]', "content", title);
    }
    setMeta(
      'meta[property="og:url"]',
      "content",
      `https://peptidecooler.co.uk${path}`,
    );

    // Canonical
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `https://peptidecooler.co.uk${path}`);
  }, [title, description, path]);

  return null;
}
